import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxValueAccessorDirective } from './value-accessor/checkbox';
import { DropZoneValueAccessorDirective } from './value-accessor/drop-zone';
import { SelectValueAccessorDirective } from './value-accessor/select';
import { TextAreaValueAccessorDirective } from './value-accessor/text-area';
import { TextInputValueAccessorDirective } from './value-accessor/text-input';

const directives = [
  TextInputValueAccessorDirective,
  CheckboxValueAccessorDirective,
  SelectValueAccessorDirective,
  TextAreaValueAccessorDirective,
  DropZoneValueAccessorDirective,
];

@NgModule({
  imports: [FormsModule, ReactiveFormsModule, ...directives],
  exports: [FormsModule, ReactiveFormsModule, ...directives],
})
export class AlbertFormsModule {}
